module.exports = __webpack_public_path__ + "img/translated-captions.e62a6e90.svg";